import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import ObjectOverride from "components/ObjectOverride";
import {Button} from "reactstrap";
import {Objects} from "../index";
import UniversalModalOverride from "../UniversalModalOverride";
import APPCONFIG from "../../constants/Config";
import API from "@beardeddevops/react.api"

/**
 *  @property {Accounts_Customizations_Object} state
 *  @property {object} model
 *  @property {Accounts_Customizations_Properties} model.properties
 *  @property {Accounts_Customizations_Is} model.is
 *  @property {Accounts_Customizations_Has} model.has
 */
class AccountCustomizations extends ObjectOverride {
	static propTypes = {
		...Framework.Components.Object.propTypes,
	};

	constructor(props) {
		super(props, Types.Accounts_Customizations._name);
	}

	/**
	 * @param prevProps
	 * @param {Accounts_Customizations_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
	}

	pendingComplete = (data) => {
		this.state.account_signature = data.account_signature;
		this.update = 'POST_SIGNATURE';
		this.handleSubmit().then();
		this.setState({signature: true});
	};

	downloadPDFs = async () => {
		let zip_bound_book_queue = new API.BuildClass(Types.Locations_Bound_Books_Queues._name, API.RequestType.CREATE);
		zip_bound_book_queue.object.zip_file = true;
		zip_bound_book_queue.parent = this.props.id ? this.props.id : 0;

		const firstUnarchivedLocation = this.props.rootState.locations.find(location => location.archived === false);
		zip_bound_book_queue.grandparent = firstUnarchivedLocation.binary_id + '-' + firstUnarchivedLocation.pkey;
		zip_bound_book_queue.object.location_binary_id = firstUnarchivedLocation.binary_id;
		zip_bound_book_queue.object.location = firstUnarchivedLocation.pkey;
		let result = await zip_bound_book_queue.submit(null, API.RequestType.CREATE);

		this.props.history.push(`/locations/${firstUnarchivedLocation.binary_id}-${firstUnarchivedLocation.pkey}#downloads`);

	}

	generateAccountPDFs = async () => {
		let pdfModel = new API.BuildClass(Types.Forms_Results._name, 'GET_ALL_ACCOUNT_FORMS_INTO_SERVER');
		let res = await pdfModel.submit(this, 'GET_ALL_ACCOUNT_FORMS_INTO_SERVER');
	}

	afterSubmit = () => {
		window.location.reload();
	}

	form = () => {
		/** @type {Accounts_Customizations_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Customizations_Object} object */
		let object = this.state;
		return (
			<>
				<Card>
					<CardContent style={{paddingBottom: 0}}>
						<div className={"row"}>
							<div className={"col-md"}>
								<Objects.DropBoxConnect
									url={'accounts#customizations'}
								/>

								{/*This is a dev only thing, that is used if someone pays to back generate PDFs*/}
								{/*{this.props.rootState.account_number === 1 ?*/}
								{/*	<div>*/}
								{/*		<h4 className="section-title">PDF Generator</h4>*/}
								{/*		<div className="form-group">*/}
								{/*			Generate all pdfs onto the server*/}
								{/*		</div>*/}
								{/*		<div className="form-group">*/}
								{/*			/!*show button if no refresh token, else show text that its connected and possibly how to disconnect*!/*/}
								{/*			<Button color="success" onClick={this.generateAccountPDFs}>PDF Generator</Button>*/}

								{/*		</div>*/}
								{/*	</div> : null}*/}
							</div>


							<div className={"col-md"}>
								<div>
									<h4 className="section-title">Show Side Navigation Arrows</h4>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.arrow_setting}
											value={object.arrow_setting}
											error={object.arrow_setting_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								{this.props.rootState.hasPawnModule &&
									<div>
										<h4 className="section-title">Pawn Customizations</h4>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Pawn Inventory"}
												value={object.inventory}
												error={object.inventory_error}
												property={properties.inventory}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Pawn Ticket"}
												value={object.ticket}
												error={object.ticket_error}
												property={properties.ticket}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>}
								{this.props.rootState.hasImporterModule &&
									<div>
										<h4 className="section-title">Account Signature (Used only for Importer Module)</h4>
										<div className="form-group">
											{object.signature ? "You have an account signature" : "You do not have an account signature"}
										</div>
										<div className="form-group">
											<Button color="green-meadow" onClick={() => this.setState({accountSign: !this.state.accountSign})}>Change Account
												Signature</Button>
										</div>
									</div>}


							</div>
						</div>

						<UniversalModalOverride
							name={"Signature"}
							locations={this.props.locations}
							states={this.props.states}
							kiosks={this.props.kiosks}
							history={this.props.history}
							object={Objects.AccountSign}
							toggle={this.state.accountSign}
							size={"lg"}
							afterSave={this.pendingComplete}
							reportClose={this.reportClose('accountSign')}
						/>

					</CardContent>
				</Card>
			</>
		)
	}

	render() {
		//TODO: would be cool to make this a popup that you can show elsewhere in the future

		// let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		// if (hasModal) {
		// 	return this.form();
		// }

		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>

				<CardActions style={{justifyContent: 'end', padding: '14px'}}>
					<Button color="primary" onClick={this.handleSubmit}>Save</Button>
				</CardActions>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(AccountCustomizations);
